import { useCallback, useEffect, useState } from 'react';
import { useCapabilities } from './useCapabilities';
import { useInvoiceV2Enabled } from '../services/invoiceV2';

export function useConsoleNavigation(tramiteId) {
    const { hasCapability } = useCapabilities();
    const salesEnabled = hasCapability('ventas_electricidad');
    const invoicesEnabled = useInvoiceV2Enabled(hasCapability('gestion_facturas'));
    const [selected, setSelected] = useState(tramiteId && salesEnabled ? 'sales' : 'home');
    const activeModule = (selected === 'sales' && !salesEnabled)
        ? 'home' : selected;
    const selectModule = useCallback(module => {
        if (module === 'home' || (module === 'sales' && salesEnabled)) {
            setSelected(module);
        }
    }, [salesEnabled]);

    useEffect(() => {
        // A conversation or call can load a sales case from the welcome screen.
        if (tramiteId && tramiteId !== 'loading' && salesEnabled) {
            setSelected(previous => previous === 'home' ? 'sales' : previous);
        }
    }, [tramiteId, salesEnabled]);

    return { activeModule, salesEnabled, invoicesEnabled, selectModule };
}
